/**
 * Saúde operacional da empresa (admin).
 * @typedef {'operante' | 'atencao' | 'bloqueada'} TenantHealthLevel
 * @typedef {{ level: TenantHealthLevel, label: string, issues: string[] }} TenantHealth
 */

/**
 * @param {Record<string, unknown>} tenant — linha de GET /admin/tenants
 * @returns {TenantHealth}
 */
export function resolveTenantOperationalHealth(tenant) {
  const issues = [];
  const status = String(tenant?.status || '');
  const blockedManual = status === 'blocked';
  const blockedBilling = Number(tenant?.billing_overdue_blocked) === 1;

  if (blockedManual) {
    issues.push('Empresa bloqueada manualmente');
  }
  if (blockedBilling) {
    issues.push('Bloqueada por mensalidade em atraso');
  }

  const hasErp = String(tenant?.erp_client_id || '').trim() !== '';
  if (!hasErp) {
    issues.push('Sem ID ERP (X-Auth)');
  }

  const hasSh = tenant?.software_house_id != null && Number(tenant.software_house_id) > 0;
  const shTokenOk = Number(tenant?.wa_sh_api_token_configured) === 1;
  if (hasSh && !shTokenOk) {
    issues.push('SH ligada sem token cliente WhatsApp');
  }

  const payOnline = Number(tenant?.payment_online_enabled) === 1;
  const mpTok = Number(tenant?.mp_token_configured) === 1;
  const mpOauth =
    String(tenant?.mercadopago_client_id || '').trim() !== '' &&
    Number(tenant?.mp_oauth_secret_configured) === 1;
  if (payOnline && !mpTok && !mpOauth) {
    issues.push('Pagamento online ativo sem Mercado Pago configurado');
  }

  if (blockedManual || blockedBilling) {
    return { level: 'bloqueada', label: 'Bloqueada', issues };
  }

  const softIssues = issues.filter(
    (msg) =>
      msg !== 'Empresa bloqueada manualmente' && msg !== 'Bloqueada por mensalidade em atraso',
  );

  if (softIssues.length > 0) {
    return { level: 'atencao', label: 'Atenção', issues: softIssues };
  }

  return { level: 'operante', label: 'Operante', issues: [] };
}
